// extracted by mini-css-extract-plugin
export default {"root":"side_panel_row_tooltip-module___root___ad80e305"};